import React from 'react'
import { useTranslation } from 'react-i18next'

import { ProgressBar } from 'primereact/progressbar'

import { useBackgroundTaskStatus } from '../../../../data/batchstatus/hooks'
import { BackgroundTaskStatus } from '../../../../data/batchstatus/models'

interface Props {
  visible: boolean
  isDelete: boolean
  isCreate: boolean
  isSupplierProcess: boolean
  backgroundStatus?: BackgroundTaskStatus
}

export const Progressbar: React.FC<Props> = ({
  visible,
  isDelete,
  isCreate,
  isSupplierProcess,
  backgroundStatus,
}) => {
  const { t } = useTranslation()
  const valueTemplate = () => {
    if (backgroundStatus) {
      return (
        <React.Fragment>
          {isCreate ? (
            <>
              {!isSupplierProcess
                ? t('roleAssignments.table.backroundTask.create.process', {
                    processed: backgroundStatus.processedItems,
                    total: backgroundStatus.totalItems,
                  })
                : t('suppliers.table.backroundTask.create.process', {
                    processed: backgroundStatus.processedItems,
                    total: backgroundStatus.totalItems,
                  })}
            </>
          ) : (
            <>
              {!isSupplierProcess
                ? t('roleAssignments.table.backroundTask.delete.process', {
                    processed: backgroundStatus.processedItems,
                    total: backgroundStatus.totalItems,
                  })
                : t('suppliers.table.backroundTask.delete.process', {
                    processed: backgroundStatus.processedItems,
                    total: backgroundStatus.totalItems,
                  })}
            </>
          )}
        </React.Fragment>
      )
    }
    return <></>
  }
  return (
    <>
      <div className="col-12" style={{ marginBottom: '0.5rem' }}>
        {valueTemplate()}
      </div>
      <div className="card col-12">
        <ProgressBar
          value={
            (backgroundStatus?.processedItems! * 100) /
            backgroundStatus?.totalItems!
          }
          className="h-1rem"
        />
      </div>
    </>
  )
}
